/*
*@Author: dcl
*@Description: 机构基本信息
*@Date: 2022-11-14 11:27:35
*/
<template>
    <div class="ib-box">
        <div class="box-right">
            <div class="right-txt">机构全称：东风南方保险代理有限公司</div>
            <div class="right-txt">机构简称：东风南方保代</div>
            <div class="right-txt">机构设立时间：2016年3月</div>
            <div class="right-txt">机构全称：东风南方保险代理有限公司</div>
            <div class="right-txt">注册资本：5000万元</div>
            <div class="right-txt">机构注册地址：广州市花都区风神大道11号之八二楼</div>
            <!-- <div class="right-txt">经营互联网保险业务的网站名称：易龙兴保</div>
            <div class="right-txt">经营互联网保险业务的网站地址：<a href="http://www.elongai.com" target="_blank"
                    rel="noopener noreferrer">www.elongai.com</a>
            </div> -->
            <div class="right-txt">公司信息披露网站地址：<a href="https://www.dfsi.cn/#/information" target="_blank"
                    rel="noopener noreferrer">www.dfsi.cn</a></div>
        </div>
        <div class="box-left">
            <el-image class="left-pot" :src="pot" />
            <el-image class="left-info2" :src="info_2" :preview-src-list="srcList" />
            <el-image class="left-info3" :src="info_3" :preview-src-list="srcList" />
            <!-- <div class="left-txt">营业执照：<a href="/static/img/info_2.png" target="_blank" rel="noopener noreferrer">点击查看</a></div>
        <div class="left-txt">经营保险代理业务许可证：<a href="/static/img/info_3.png" target="_blank" rel="noopener noreferrer">点击查看</a></div> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pot: require('../../assets/base_pot.png'),
            info_2: require('../../assets/info_2.png'),
            info_3: require('../../assets/info_3.jpg'),
            srcList: [require('../../assets/info_2.png'), require('../../assets/info_3.jpg')],
            baseList: [{
                key: "机构全称",
                value: "东风南方保险代理有限公司"
            },
            {
                key: "机构简称",
                value: "东风南方保代"
            },
            {
                key: "机构设立时间",
                value: "2016年3月"
            },
            {
                key: "注册资本",
                value: "5000万元"
            },
            {
                key: "机构注册地址",
                value: "广州市花都区风神大道11号之八二楼"
            },
            {
                key: "经营互联网保险业务的网站名称",
                value: "易龙兴保"
            },
            {
                key: "经营互联网保险业务的网站地址",
                value: "www.elongai.cn"
            },
            {
                key: "公司信息披露网站地址",
                value: "www.dfsi.cn"
            },
            {
                key: "营业执照",
                value: "点击查看"
            },
            {
                key: "经营保险代理业务许可证",
                value: "点击查看"
            }
            ]
        };
    }
};
</script>

<style lang="less" scoped>
.ib-box {
    display: flex;
    flex-direction: row;
    margin: .73rem 0px;
    padding: .9rem 1.13rem 1.4rem;
    color: #666666;
    background: #FAFAFA;

    .box-right {
        .right-txt {
            // display: flex;
            // flex-direction: row;
            font-size: 0.53rem;
            // margin: .32rem 0;
            line-height: 1.27rem;
        }
    }

    .box-left {
        display: flex;
        flex-direction: row;
        align-items: center;

        .left-pot {
            margin: 0 2.1rem 0 2.4rem;
            width: 0.47rem;
            height: 4.93rem;
        }

        .left-info2 {
            width: 10.43rem;
            height: 8.78rem;
        }

        .left-info3 {
            width: 10.43rem;
            height: 8.78rem;
            margin-left: 2rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Information/base.vue